import hash from "hash.js";
import moment from "moment";
import { TransferInstructionsEnum } from "./TransferInstructionsEnum";
import { AccountTypeEnum } from "./AccountTypeEnum";
import { FormValues } from "./FormValues";

export const getInitialValues: () => FormValues = () => {
  return {
    agreementId: hash
      .sha256()
      .update(String(moment().get("millisecond")) + Math.random())
      .digest("hex"),
    currentFirm: "",
    currentAccount: "",
    currentAccountType: "",
    initialFundingDate: "",
    toAccountType: AccountTypeEnum.TraditionalIRA,
    rothPortion: "",
    rothYear: "",
    transferInstructions: TransferInstructionsEnum.All,
    transferDollarEstimate: undefined,
    transferDollarAmount: undefined,
    transferPercent: "",
    firstName: "",
    lastName: "",
    birthDate: "",
    ssn: "",
    email: "",
    primaryPhone: "",
    secondaryPhone: "",
    byo: false,
    transferToSame: true,
    fund1: "",
    fund1Code: "",
    fund1Percent: null,
    fund2: "",
    fund2Code: "",
    fund2Percent: null,
    fund3: "",
    fund3Code: "",
    fund3Percent: null,
    fund4: "",
    fund4Code: "",
    fund4Percent: null,
    signature: "",
    dateSigned: ""
  };
};
